import React from "react";

// PNG silhouette imports — transparent background, white outlines
import frontRelaxed from "../assets/silhouettes/front-relaxed.png";
import sideRelaxed from "../assets/silhouettes/side-relaxed.png";
import backRelaxed from "../assets/silhouettes/back-relaxed.png";
import frontFlex from "../assets/silhouettes/front-flex.png";
import sideFlex from "../assets/silhouettes/side-flex.png";
import backFlex from "../assets/silhouettes/back-flex.png";
import favorite from "../assets/silhouettes/favorite.png";

const POSE_MAP = {
  front: { src: frontRelaxed },
  side: { src: sideRelaxed, scale: 0.88 },
  back: { src: backRelaxed },
  "front-flex": { src: frontFlex },
  "side-flex": { src: sideFlex, scale: 0.88 },
  "back-flex": { src: backFlex },
  favorite: { src: favorite },
};

export default function BodySilhouetteOverlay({
  pose = "front",
  className = "",
  opacity = 0.2,
}) {
  const entry = POSE_MAP[pose] || POSE_MAP.front;
  const scale = entry.scale || 1;

  return (
    <img
      src={entry.src}
      alt=""
      className={className}
      style={{ opacity, objectFit: "contain", transform: scale !== 1 ? `scale(${scale})` : undefined }}
      draggable={false}
      aria-hidden="true"
    />
  );
}

// ---------------------------------------------------------------------------
// Utility: UI label → pose variant key
// ---------------------------------------------------------------------------
export function poseToVariant(poseLabel) {
  if (!poseLabel) return "front";
  const lower = poseLabel.toLowerCase().trim();

  if (/front.*flex/i.test(lower)) return "front-flex";
  if (/side.*flex/i.test(lower)) return "side-flex";
  if (/back.*flex/i.test(lower) || /lat.*spread/i.test(lower)) return "back-flex";
  if (/fav/i.test(lower)) return "favorite";
  if (/front/i.test(lower)) return "front";
  if (/side/i.test(lower) || /lateral/i.test(lower)) return "side";
  if (/back/i.test(lower) || /rear/i.test(lower) || /posterior/i.test(lower)) return "back";

  return "front";
}

// ---------------------------------------------------------------------------
// Utility: UI label → DB photo key
// ---------------------------------------------------------------------------
export function poseToPhotoKey(poseLabel) {
  if (!poseLabel) return "photo_front";
  const lower = poseLabel.toLowerCase().trim();

  if (/front.*relax/i.test(lower)) return "photo_front";
  if (/front.*flex/i.test(lower)) return "photo_front_flex";
  if (/side.*relax/i.test(lower)) return "photo_side";
  if (/side.*flex/i.test(lower)) return "photo_side_flex";
  if (/back.*relax/i.test(lower)) return "photo_back";
  if (/back.*flex/i.test(lower) || /lat.*spread/i.test(lower)) return "photo_back_flex";
  if (/fav/i.test(lower)) return "photo_relaxed";
  if (/front/i.test(lower)) return "photo_front";
  if (/side/i.test(lower)) return "photo_side";
  if (/back/i.test(lower)) return "photo_back";

  return "photo_front";
}
